import { dataCnyCircleSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCnyCircleSolid = /*#__PURE__*/createIcon(dataCnyCircleSolid)
export default IconCnyCircleSolid
